import { Blueprints } from './components/Blueprints';

export default Blueprints;
